import { render } from "./AllDetailInfo.vue?vue&type=template&id=6517a7af&scoped=true"
import script from "./AllDetailInfo.vue?vue&type=script&lang=js"
export * from "./AllDetailInfo.vue?vue&type=script&lang=js"

import "./AllDetailInfo.vue?vue&type=style&index=0&id=6517a7af&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6517a7af"]])

export default __exports__